import React from 'react';

import SearchBlock from '../../../SearchBlock';
import EditIcon from '../EditIcon';

const computeQExpansionValue = (qExpansion) => {
  const numeric = parseInt(qExpansion, 10);
  if (numeric && numeric > 999) {
    return `${numeric / 1000}km`;
  }
  return qExpansion ? `${numeric}m` : '';
};

export default function Locations({
  mainLocation,
  additionalLocations,
  qExpansion,
  editQExpansion,
  editQExpansionOnKeyPress,
  startLocalitySearch,
  startLocalitySearchOnKeyPress,
  isMobile,
  text,
}) {
  const hasChildren = additionalLocations && additionalLocations.length > 0;
  const hasQExpansion = qExpansion && qExpansion !== '0';

  const expansionValue = hasQExpansion ? computeQExpansionValue(qExpansion) : '';

  const qExpansionComponent = hasQExpansion ? (
    <SearchBlock
      label="e dintorni entro"
      button={expansionValue}
      className="sentenceElement"
      onClickAction={editQExpansion}
      onKeyPressAction={editQExpansionOnKeyPress}
      icon={<EditIcon isMobile={isMobile} />}
      ariaLabel={`Nei dintorni entro ${qExpansion} metri`}
      ariaDescription="Modifica la distanza dei dintorni"
      ariaHaspopup="dialog"      
      smaller
      shorterOnMobile      
    />
  ) : null;

  return hasChildren && hasQExpansion ? (
    <div style={{ display: 'flex', flexGrow:1, flexWrap: 'wrap', justifyContent: 'center', width: 'calc(100% - 32px)' }}>
      <SearchBlock
        label={text.prefix}
        button={text.label}
        more={text.additional}
        onClickAction={startLocalitySearch}
        onKeyPressAction={startLocalitySearchOnKeyPress}
        className="sentenceElement"
        icon={<EditIcon isMobile={isMobile} />}
        ariaLabel={text?.ariaLabel}
        ariaHaspopup="dialog"
        isLocality
        column
        smaller        
      />
      {qExpansionComponent}
    </div>
  ) : (
    <>
      <SearchBlock
        label={text.prefix}
        button={text.label}
        more={text.additional}
        className="sentenceElement"
        isPlaceholder={!mainLocation}
        icon={<EditIcon isMobile={isMobile} />}
        onClickAction={startLocalitySearch}
        onKeyPressAction={startLocalitySearchOnKeyPress}
        smaller={hasChildren}
        column={hasChildren}
        ariaLabel={text?.ariaLabel}
        ariaHaspopup="dialog"
        isLocality
      />
      {qExpansionComponent}
    </>
  );  
}
